module.exports = new __parcel__URL__("koala.730a01eb.svg").toString();